import React from "react";
import { useQuery } from "react-query";
import { useAuth } from "../../../context/AuthContext";
import StatCard from "../../../components/shared/StatCard";
import DataTable from "../../../components/shared/DataTable";
import { formatDate, statusBadgeClass, formatCurrency } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function LabDashboard() {
  const { user } = useAuth();

  const { data } = useQuery("lab-dashboard", () =>
    api.get("/lab/dashboard")
  );

  const recentColumns = [
    { key: "patientName", label: "Patient" },
    { key: "tests", label: "Tests" },
    {
      key: "scheduledAt",
      label: "Date",
      render: (row) => formatDate(row.scheduledAt, "dd MMM, hh:mm a"),
    },
    { key: "collectionType", label: "Collection" },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display font-bold text-2xl text-slate-900">
          Welcome, {user?.name} 🧪
        </h2>
        <p className="text-slate-500 text-sm mt-1">Your lab overview</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard title="Today's Bookings" value={data?.todayBookings ?? 0} icon="📅" color="primary" />
        <StatCard title="Total Bookings" value={data?.totalBookings ?? 0} icon="📋" color="success" />
        <StatCard
          title="Revenue (Month)"
          value={formatCurrency(data?.monthlyRevenue ?? 0)}
          icon="💰"
          color="teal"
        />
      </div>

      <div className="card">
        <h3 className="font-display font-semibold text-slate-800 mb-4">Recent Bookings</h3>
        <DataTable
          columns={recentColumns}
          data={data?.recentBookings || []}
          emptyMessage="No bookings yet."
        />
      </div>
    </div>
  );
}
